import { useMemo } from "react";
import { capitalize } from "lodash";

import "./WarnBrowser.scss";

export default function WarnBrowser() {
  const getBrowser = (): string => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isGoogleBot = userAgent.includes("googlebot");
    const isIE = !!(document as any).documentMode;
    const isEdge = !isIE && !!(window as any).StyleMedia;
    const isFirefox = typeof (window as any).InstallTrigger !== "undefined";
    const isOpera =
      (!!(window as any).opr && !!(window as any).opr.addons) ||
      !!(window as any).opera ||
      userAgent.includes("opr/");
    const isChrome =
      !isGoogleBot &&
      !isEdge &&
      !isOpera &&
      !!(window as any).chrome &&
      (!!(window as any).chrome.webstore ||
        navigator.vendor.toLowerCase().includes("google inc."));
    const isSafari = !isChrome && userAgent.includes("safari");
    const isBlink = (isChrome || isOpera) && !!(window as any).CSS;

    if (isIE) {
      return "ie";
    }
    if (isEdge) {
      return "edge";
    }
    if (isFirefox) {
      return "firefox";
    }
    if (isOpera) {
      return "opera";
    }
    if (isChrome) {
      return "chrome";
    }
    if (isSafari) {
      return "safari";
    }
    if (isBlink) {
      return "blink";
    }
    if (isGoogleBot) {
      return "googlebot";
    }
    return "unknown";
  };

  const browser = useMemo(() => getBrowser(), []);
  const isIOS = useMemo(() => {
    return navigator.userAgent.toLowerCase().includes("ios");
  }, []);

  if (browser === "unknown" || browser === "chrome" || isIOS) {
    return null;
  }

  const browserName = browser === "ie" ? "Internet Explorer" : browser;

  return (
    <div className="browserMessage">
      <strong>Mitt</strong>Kontor är inte anpassad för din webbläsare (vi ser
      att du använder {capitalize(browserName)}). Sidan fungerar bäst i{" "}
      <a target="_blank" rel="noreferrer" href="https://www.google.com/chrome">
        Chrome
      </a>
      .
    </div>
  );
}
